import { Component } from '@angular/core';
import { MainService } from '../components/shared/main.service';
import { localStorageService } from '../components/shared/localstorage.service';
import { ApiService } from '../components/shared/api.service';
import { DatePipe } from '@angular/common';
import { SharedService } from '../components/shared/shared.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-export-btn',
  standalone: true,
  imports: [],
  templateUrl: './export-btn.component.html',
  styleUrl: './export-btn.component.scss'
})
export class ExportBtnComponent {
  is_dummy: any = this._local.customGetItem('is_dummy') ? this._local.customGetItem('is_dummy') : 0;
  country_id: any = this._local.customGetItem('country_id') ? this._local.customGetItem('country_id') : 0;

  constructor(
    public _main: MainService,
    public _shared: SharedService,
    private datePipe: DatePipe,
    public router: Router,
    public route: ActivatedRoute,
    public _api: ApiService,
    public _local: localStorageService
  ) { }


  exportXLSX(ext: any) {
    let data = {
      country_id: 1,
      is_export: 1
    }
    this._api.api(data, 'guest/get_accounts', 'get').subscribe((data: any) => {
      if (!data.is_error) {
        this._shared.customPopups("Your data is being processed and will arrive in your email inbox within 2 to 5 minutes.", 0);
      }
    }, (error: any) => {
      console.log(error);
    });
  }


}
